module.exports = __webpack_public_path__ + "static/img/yiti_06.49fb2a7f.jpg";